// extracted by mini-css-extract-plugin
export default {"modal":"jS-z","modalOverlay":"kS-z","outfitHeading":"lS-z"};